import { Link, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react';

import { isIOSApp } from '#features/api/utils/appCheck';

export const ReCaptchaCaption = () => {
  if (isIOSApp()) return null;
  return (
    <Text textStyle="caption">
      <Trans
        id="auth.recaptcha.warning"
        components={{
          1: <Link color="fg.link" href="https://policies.google.com/privacy" target="_blank" />,
          2: <Link color="fg.link" href="https://policies.google.com/terms" target="_blank" />,
        }}
      />
    </Text>
  );
};
